module.exports = __webpack_public_path__ + "img/otto-logo-title.16c7650f.svg";